















import Vue from 'vue';

// Vuex
import { mapGetters } from 'vuex';

import NavigationTabs from '@/components/NewManOfTheMatch/ManOfTheMatchNavigationTabs.vue';
import ManOfTheMatchCompetition from '@/components/NewManOfTheMatch/ManOfTheMatchCompetition.vue';
import ManOfTheMatchSettings from '@/components/NewManOfTheMatch/ManOfTheMatchSettings.vue';

export default Vue.extend({
	name: 'ManOfTheMatch',

	components: {
		NavigationTabs,
		ManOfTheMatchCompetition,
		ManOfTheMatchSettings,
	},

	data: () => ({
		tab: 1,
		show: true,
		selectedManOfTheMatch: null as any,
	}),

	computed: {
		...mapGetters(['loading']),
	},

	methods: {
		tabChanged(tabNumber: number) {
			this.tab = tabNumber;
		},
		async getInitialData() {
			const manOfTheMatchId = this.$route.params.id;
			const selectedManOfTheMatch = await this.$store.dispatch('getManOfTheMatchById', { manOfTheMatchId });
			this.selectedManOfTheMatch = selectedManOfTheMatch;
			console.log('this.selectedManOfTheMatch = ', this.selectedManOfTheMatch);
			this.$store.commit('setBreadcrumb', { root: 'Man Of The Match', path: this.selectedManOfTheMatch.name });
			this.$store.commit('setLoadingState', false);
		},
	},
	async mounted() {
		this.getInitialData();
	},
});
